<template>
    <div class="dsf-footer">
        <slot name="content">
            <button
                v-if="$slots.ok"
                class="_button dsf-button dsf-ok"
                :disabled="disableOk"
                @click="$emit('dsfOk')"
            >
                <slot name="ok"></slot>
            </button>
            <button
                v-if="$slots.cancel"
                class="_button dsf-button dsf-cancel"
                :disabled="disableCancel"
                @click="$emit('dsfCancel')"
            >
                <slot name="cancel"></slot>
            </button>
        </slot>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    disableCancel?: boolean;
    disableOk?: boolean;
}>();

defineSlots<{
    content: (props: {}) => any;
    cancel: (props: {}) => any;
    ok: (props: {}) => any;
}>();

defineEmits<{
    dsfCancel: [];
    dsfOk: [];
}>();
</script>

<style scoped lang="scss">
.dsf-footer {
    position: sticky;
    bottom: 0;
    background-color: var(--panel);
    padding: 12px 18px;
    display: flex;
    justify-content: end;
    gap: 12px;
    border-top: 1px solid var(--accentedBg);

    > .dsf-button {
        padding: 8px 16px;
        font-weight: bold;
        border-radius: var(--radius);
        min-width: 40px;

        &:not(:disabled) {
            border: 1px solid var(--accentedBg);
            color: var(--accent);

            &:hover {
                background-color: var(--accentedBg);
            }
        }

        &:disabled {
            border: 1px solid transparent;
            opacity: 0.7;
        }

        &:not(.dsf-ok) {
            font-weight: normal;
        }
    }
}
</style>
